// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/plugins/Localization

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function TempElementLocalesBlock(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'TempElementLocalesBlock',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fill: 'currentColor',
      d: 'M5 6v5h6V6H5zm-1 4.578C2.241 9.8 1 8.034 1 6c0-2.743 2.257-5 5-5 2.401 0 4.43 1.729 4.898 4H6.525a.43.43 0 00.127-.09c.435-.434-.216-1.086-.216-1.086.434-.653.216-1.74.216-1.74-1.086-.215-3.695 0-3.695 2.174 0 .94.489 1.474 1.043 1.777v4.543zM10 10H6V7h4v3zM5.093 5c.156-.285.473-.524.473-.524s.305.405.635.524H5.093z',
    })
  );
}
